/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const title = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 5.417h2.267V12h1.466V5.417H10V4H4v1.417ZM20 16H4v-1.5h16V16Zm-7 4H4v-1.5h9V20Z" />
	</SVG>
);

export default title;
